import React, { ReactElement, useRef } from 'react';
import { useSpring, animated } from 'react-spring';
import { Typography, TypographyVariants } from '../../ui/typography';
import style from './style.module.scss';

import image1 from '../../../images/films/1.webp';
import image2 from '../../../images/films/2.webp';
import image3 from '../../../images/films/3.webp';

import { useIntersectionObserver } from '../../../utils/hooks/useIntersectionObserver';

export const WatchFirstSection = (): ReactElement => {
  const sectionRef = useRef<HTMLElement>();
  const isVisible = useIntersectionObserver(sectionRef, '0px', 0.5);

  const firstFilm = useSpring({ x: isVisible ? '0' : '-100%' });
  const secondFilm = useSpring({
    y: isVisible ? 0 : 50, opacity: isVisible ? 1 : 0, config: { duration: 500 },
  });
  const thirdFilm = useSpring({ x: isVisible ? '0' : '100%' });

  return (
    <section className={style.section}>
      <Typography className={style.title} variant={TypographyVariants.h2}>Смотрите первыми</Typography>
      <div className={style.films} ref={sectionRef as any}>
        <animated.img style={firstFilm} className={style.image} alt='Фильм "Довод"' src={image1} />
        <div className={style.mainImage}>
          <animated.img style={secondFilm} className={style.image} alt='Фильм "Не время умирать"' src={image2} />
          <animated.div style={secondFilm} className={style.shade} />
        </div>
        <animated.img style={thirdFilm} className={style.image} alt='Фильм "Джон Уик 3"' src={image3} />
      </div>
      <div className={style.description}>
        <Typography className={style.descriptionTitle} variant={TypographyVariants.h3} highlight>Смотрите вместе кинопремьеры</Typography>
        <Typography variant={TypographyVariants.body}>Вы можете смотреть громкие кинопремьеры на любимом сервисе вместе с друзьями. Все, что вам нужно - установленное расширение. </Typography>
      </div>
    </section>
  );
};
